module.exports = __webpack_public_path__ + "static/media/house-icon.2a61c901.svg";